<template>
    <aside class="creator-sidebar" aria-label="创作者中心导航">
        <p class="creator-sidebar-label">Creator space</p>
        <nav class="creator-side-nav">
            <button
                v-for="item in items"
                :key="item.key"
                class="creator-nav-item"
                :aria-current="item.key === activeKey ? 'page' : null"
                type="button"
                @click="$emit('select', item.key)">
                {{ item.label }}
            </button>
        </nav>
    </aside>
</template>

<script>
export default {
    name: "CreatorCenterSidebar",
    props: {
        items: {
            type: Array,
            required: true,
        },
        activeKey: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped>
.creator-sidebar {
    grid-row: 2;
    padding: 20px 12px;
    background: #fff;
    border-right: 1px solid #f0dbd5;
}

.creator-sidebar-label {
    margin: 2px 10px 16px;
    color: #9370a4;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .14em;
    text-transform: uppercase;
}

.creator-side-nav {
    display: grid;
    gap: 4px;
}

.creator-nav-item {
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 50px;
    padding: 0 10px 0 14px;
    color: #4b405b;
    text-align: left;
    background: transparent;
    border: 0;
    border-radius: 12px;
    cursor: pointer;
    font: inherit;
    font-size: 15px;
    font-weight: 600;
    transition: background-color 180ms ease, color 180ms ease;
}

.creator-nav-item::before {
    width: 4px;
    height: 18px;
    margin-right: 12px;
    content: "";
    background: transparent;
    border-radius: 999px;
    transition: background-color 180ms ease;
}

.creator-nav-item:hover {
    background: #f3edff;
}

.creator-nav-item[aria-current="page"] {
    color: #674088;
    background: #ffe4ee;
}

.creator-nav-item[aria-current="page"]::before {
    background: #f16f98;
}

.creator-sidebar-note {
    margin: 28px 12px 0;
    padding-top: 20px;
    color: #8d8493;
    border-top: 1px solid #f1e2dc;
    font-size: 12px;
    line-height: 1.7;
}
</style>
